module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    class: {
      active: this.$store.state.menuActive
    }
  }, [_c('button', {
    staticClass: "toggle-nav",
    on: {
      "click": function($event) {
        return _vm.toggleNavigation()
      }
    }
  }, [_c('span', [_vm._v(">")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "loud",
    on: {
      "click": function($event) {
        return _vm.toggleNavigation()
      }
    }
  }, [_c('router-link', {
    staticClass: "slide-i-o",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("\n                        About\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "loud",
    on: {
      "click": function($event) {
        return _vm.toggleNavigation()
      }
    }
  }, [_c('router-link', {
    staticClass: "slide-i-o",
    attrs: {
      "to": "/about/timeline"
    }
  }, [_vm._v("\n                          Education / Experience\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "loud",
    on: {
      "click": function($event) {
        return _vm.toggleNavigation()
      }
    }
  }, [_c('router-link', {
    staticClass: "slide-i-o",
    attrs: {
      "to": "/project"
    }
  }, [_vm._v("\n                          Projects\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "loud",
    on: {
      "click": function($event) {
        return _vm.toggleNavigation()
      }
    }
  }, [_c('router-link', {
    staticClass: "slide-i-o",
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("\n                          Contact / CV\n            ")])], 1)])]), _vm._v(" "), _c('main', {
    staticClass: "wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "component-fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d22304a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 13
// module chunks = 7